<template>
    <div
        class="m-changePrices t-shops-wrapper sth overflow-visible"
        style="--width-md: 100%; position: relative"
    >
        <div class="t-shops-options" v-if="priceGroupIdx > 0">
            <button
                @click="
                    $store.dispatch('removePriceGroup', {
                        promoId: promotion.id,
                        groupId: promotion.groupId,
                        groupIdx: priceGroupIdx,
                        previewType
                    })
                "
                class="close"
            >
                <span>×</span>
            </button>
        </div>
        <div
            v-if="previewType !== 'labels' && !isNoItemsPromo"
            class="m-changePrices__header"
            :class="{ '--isMargin': isMargin }"
            style="border-top: 0; padding-top: 0"
        >
            <span>
                {{ hasSets ? 'Zestawy promocyjne' : 'Produkty promocyjne' }}
            </span>
            <span class="d-none d-sm-flex align-items-center" v-if="isMargin">
                Marża %
                <a-icon
                    v-tooltip="$store.getters.getWholesalePriceMarginTooltip('all')"
                    style="width: 14px; height: 14px; margin-left: 0.5rem;"
                    icon="Info"
                />
            </span>

            <span
                v-if="
                    promotion.equalLocalCodes &&
                        !promotion.all_eans_present &&
                        !hasSets
                "
            >
                Kod lokalny
            </span>
            <template
                v-if="
                    promotion.type !== PROMO_TYPES.SALES_TARGET &&
                        promotion.subscriptionsEqualPrices &&
                        promotion.subscriptionsEqualPrices.equalPrices
                "
            >
                <span v-if="showItemInput">Cena <span class="nowrap">za sztukę</span></span>

                <span v-if="promotion.type === PROMO_TYPES.QUOTA">Rabat brutto</span>
                <span v-else-if="promotion.type === PROMO_TYPES.BONDED_QUOTA">
                    Rabat brutto <span class="nowrap">do zestawu</span>
                </span>
                <span v-else-if="promotion.type === PROMO_TYPES.BONDED_PERCENTAGE">
                    Rabat % <span class="nowrap">do zestawu</span>
                </span>

                <span v-else-if="$store.getters.isWeight(promotion.type)">
                    Cena <span class="nowrap">w promocji</span>
                    <span class="nowrap"> za KG</span></span>
                <span v-else>
                    <span>{{ hasSets ? 'Twoja cena zestawu' : 'Cena' }}</span>
                    w promocji
                </span>
            </template>
        </div>

        <div class="t-shops-products overflow-visible">
            <template v-if="hasSets && previewType !== 'labels'">
                <change-price-product-sets
                    v-for="(productSet, idxx) in productSets"
                    @priceChange="val => (productSet.priceChange = val)"
                    :product-set="productSet"
                    :key="idxx"
                    :set-idx="idxx"
                    :promotion="promotion"
                    :group-id="promotion.groupId"
                    :group-idx="priceGroupIdx"
                    :merchant-ids="searchedShopsIds"
                />
            </template>
            <template v-else>
                <template v-if="previewType === 'labels'">
                    <div class="custom-checkbox mb-3">
                        <the-btn
                            text="Zaznacz wszystkie główne"
                            class="btn-outline-custom d-none d-sm-inline-flex"
                            :class="{ 'd-inline-flex': !allowSelectAll }"
                            icon="CheckCorrect"
                            @click.native="selectAllProducts(true)"
                        />
                        <the-btn
                            text="Odznacz wszystkie"
                            class="btn-danger ml-sm-2 d-none d-sm-inline-flex"
                            :class="{ 'd-inline-flex': allowSelectAll }"
                            icon="CheckIncorrect"
                            @click.native="selectAllProducts(false)"
                        />
                    </div>
                    <div class="m-changePrices__header pt-0 border-top-0">
                        <span>Produkt</span>
                        <span v-if="showPriceLowest" class="d-flex">
                            <span>Cena z 30 dni</span>
                            <a-icon
                                icon="Info"
                                width="16"
                                height="16"
                                v-tooltip="{
                                    content: $store.getters.isWeight(
                                        promotion.type
                                    )
                                        ? 'Najniższa cena przed obniżką'
                                        : 'Najniższa cena towaru z 30 dni przed obniżką'
                                }"
                            />
                        </span>
                        <span v-if="showRegularPriceInput">Cena poza promocją</span>
                        <span v-if="showPriceLowestDiscount">Cena za kg sprzed obniżki</span>
                        <span>Liczba kopii</span>
                        <span v-if="showExtraFieldCol" style="width: 58px; max-width: 58px;" />
                    </div>
                    <product-tree
                        class="m-labels__products"
                        :products="promotionalProducts"
                        component-name="LabelProduct"
                        :promotion="promotion"
                        :price-group-idx="priceGroupIdx"
                        :show-regular-price-input="showRegularPriceInput"
                        :show-price-lowest="showPriceLowest"
                        :show-price-lowest-discount="showPriceLowestDiscount"
                        product-class="m-labels__product"
                        preview-type="labels"
                        fetching-method-name="loadLabelsProductsAndResources"
                        :selected-labels="true"
                        @has-extra-fields="showExtraFieldCol = $event"
                    />
                </template>
                <template v-else>
                    <product-tree
                        :promotion="promotion"
                        :products="promotionalProducts"
                        :price-group-idx="priceGroupIdx"
                        fetching-method-name="fetchProductsByPromoGroupPromo"
                        component-name="ChangePriceProduct"
                        :change-by-merchants-group="true"
                        :preview-type="previewType"
                    />
                </template>
                <page-preloader
                    v-if="promotion.productsStatus === 'loading'"
                    minHeight="123px"
                />
                <the-btn
                    class="mt-3"
                    v-if="
                        promotion.productsPagination &&
                            promotion.productsPagination.nextPage
                    "
                    @click.native="showMoreProducts"
                >Pokaż więcej produktów
                </the-btn>
            </template>
        </div>
        <div
            v-if="showSelectRowForNextGroup(priceGroupIdx)"
            class="t-shops-settings"
        >
            <div class="custom-checkbox">
                <the-btn
                    text="Zaznacz wszystkie"
                    class="btn-outline-custom d-none d-sm-inline-flex"
                    :class="{ 'd-inline-flex': !allowSelectAll }"
                    icon="CheckCorrect"
                    @click.native="selectAllShops(true)"
                />
                <the-btn
                    text="Odznacz wszystkie"
                    class="
                    btn-danger
                    ml-sm-2
                    d-none d-sm-inline-flex
                "
                    :class="{ 'd-inline-flex': allowSelectAll }"
                    icon="CheckIncorrect"
                    @click.native="selectAllShops(false)"
                />
            </div>
        </div>
        <div class="t-shops scrollbar">
            <div class="scrollbar-shadow is-top"></div>
            <div
                v-if="allSubInterrupted"
                class="t-shops-error text-danger typo--sm"
            >
                Promocja została przerwana we wszystkich sklepach, aktywacja
                będzie możliwa jutro
            </div>
            <div
                v-else-if="allCheckedSubsAreInterrupted"
                class="t-shops-error text-danger typo--sm"
            >
                Promocja została przerwana w wybranych sklepach i nie zostanie
                wysłana do aktywacji. Ponowna aktywacja będzie możliwa jutro
            </div>
            <div
                v-else-if="allShopsUnchecked"
                class="t-shops-error mb-3 text-danger typo--sm"
            >
                Wybierz sklep lub usuń promocję z koszyka
            </div>
            <promotion-shop
                v-for="(sub, idx) in searchedShopsIds"
                :subscriptions="promotion.subscriptions"
                :key="idx"
                :sub="sub"
                :group-id="groupId"
                :price-group-idx="priceGroupIdx"
                :promotion="promotion"
                :active-shop="activeShop"
                @onChangeActiveShop="activeShop = $event"
                :selected-shops="promotionShops"
                :preview-type="previewType"
                :show-price-lowest="showPriceLowest"
                :show-price-lowest-discount="showPriceLowestDiscount"
            ></promotion-shop>
            <div class="scrollbar-shadow is-bottom"></div>
        </div>
    </div>
</template>

<script>
import PromotionShop from '@/components/promotions/PromotionShop'
import ChangePriceProductSets from '@/components/promotions/ChangePriceProductSets'
import promoBonded from '@/mixins/promoBonded'
import { PROMO_TYPES } from '@/utils/constants/promo-types'

export default {
    mixins: [promoBonded],
    data() {
        return {
            activeShop: 0,
            showExtraFieldCol: false
        }
    },
    props: {
        promotion: {
            type: Object,
            required: true
        },
        priceGroupIdx: {
            type: Number,
            required: true
        },
        groupId: {
            type: Number,
            required: true
        },
        previewType: {
            type: String,
            default: ''
        },
        showPriceLowest: {
            type: Boolean,
            default: false
        },
        showPriceLowestDiscount: {
            type: Boolean,
            default: false
        }
    },
    components: {
        PromotionShop,
        ChangePriceProductSets
    },
    created() {
        this.PROMO_TYPES = PROMO_TYPES
    },
    computed: {
        promotionalProducts() {
            if (this.previewType === 'labels') {
                let priceGroupWithCheckedProduct

                if (this.priceGroupIdx !== undefined) {
                    priceGroupWithCheckedProduct =
                        this.promotion.subscriptionsEqualPrices.priceGroups[
                            this.priceGroupIdx
                        ]?.find(el => el.checked)
                }

                if (priceGroupWithCheckedProduct) {
                    return priceGroupWithCheckedProduct.products
                } else {
                    return this.promotion.products
                }
            } else {
                return this.promotion.products
            }
        },

        subscriptions() {
            return this.promotion.subscriptionsEqualPrices.priceGroups[
                this.priceGroupIdx
            ]
        },
        allowSelectAll() {
            return (
                this.subscriptions.length ===
                this.subscriptions.filter(el => el.checked).length
            )
        },
        availableMerchantIds() {
            return this.$store.getters.getAvailableMerchants.map(el => el.id)
        },
        promotionShops() {
            const payload = {
                promoId: this.promotion.id,
                groupId: this.promotion.groupId
            }

            if (this.previewType === 'labels') {
                return this.$store.getters.getPromotionLabelShopsEP(payload)[
                    this.priceGroupIdx
                ]
            } else {
                return this.$store.getters.getPromotionShopsEP(payload)[
                    this.priceGroupIdx
                ]
            }
        },
        searchedShopsIds() {
            return this.promotionShops
                .filter(el =>
                    this.availableMerchantIds.includes(el.merchant_id)
                )
                .map(el => el.merchant_id)
        },
        allShopsUnchecked() {
            return this.$store.getters.atLeastOneOfSelectedPromotionsHasNoSubsActive(
                {
                    promotion: this.promotion,
                    state:
                        this.previewType === 'labels' ? 'accepted' : 'available'
                }
            )
        },
        allSubInterrupted() {
            return (
                this.previewType === 'group-accept' &&
                this.$store.getters.atLeastOneOfSelectedPromotionsHasNoSubsActive(
                    {
                        promotion: this.promotion,
                        state: 'interrupted'
                    }
                )
            )
        },
        allCheckedSubsAreInterrupted() {
            return this.previewType === 'group-accept' &&
                this.$store.getters.allCheckedSubsAreInterrupted(this.promotion)
        },
        hasSets() {
            return this.$store.getters.hasProductSets(this.promotion.type)
        },
        isMargin() {
            if (this.previewType === 'labels') {
                return false
            }

            if (!this.$store.getters.isMarginType(this.promotion.type)) {
                return false
            }

            return true
        },
        showRegularPriceInput() {
            let show = false
            if (
                this.promotion.type !== PROMO_TYPES.REGULAR_PRICE &&
                this.promotion.type !== PROMO_TYPES.WEIGHT_REGULAR_PRICE &&
                this.promotion.type !== PROMO_TYPES.WEIGHT_PERIODIC_PRICE_REDUCTION
            ) {
                show = true
                if (
                    this.promotion.type === PROMO_TYPES.PERIODIC_PRICE_REDUCTION &&
                    !this.promotion.loyalty
                ) {
                    show = false
                }
            }
            return show
        },
        hasSubProducts() {
            let isLinkedProduct = false
            if (this.promotionalProducts?.length) {
                for (const product of this.promotionalProducts) {
                    if (
                        product.promo_dict_product_eans_count ||
                        product.linked_product_set_dict_products_count
                    ) {
                        isLinkedProduct = true
                        break
                    }
                }
            }
            return isLinkedProduct
        },
        localCodeValidation() {
            return this.$store.getters.getLocalCodesValidation
        },
        productSets() {
            if (this.isBonded) {
                return this.promotion.product_sets.filter(
                    set => set.type === 'ProductSet::Promotional'
                )
            } else {
                return this.promotion.product_sets
            }
        },

        isNoItemsPromo() {
            return this.$store.getters.isNoItemsPromo(this.promotion.type)
        }
    },
    methods: {
        selectAllProducts(selected) {
            this.$store.dispatch('selectAllLabelProducts', {
                selected,
                groupId: this.groupId,
                promoId: this.promotion.id,
                priceGroupIdx: this.priceGroupIdx
            })
        },
        showSelectRowForNextGroup(priceGroupIdx) {
            const payload = {
                promoId: this.promotion.id,
                groupId: this.promotion.groupId
            }

            if (this.previewType === 'labels') {
                return !this.$store.getters.getPromotionLabelShopsEP(payload)[
                    this.priceGroupIdx + 1
                ]
            } else {
                return (
                    !this.allSubInterrupted &&
                    !this.allCheckedSubsAreInterrupted &&
                    !this.$store.getters.getPromotionShopsEP(payload)[
                        this.priceGroupIdx + 1
                    ]
                )
            }
        },
        async showMoreProducts() {
            const { product_sets } = this.promotion

            const payload = {
                per: 100,
                main: true,
                groupId: this.groupId,
                promoId: this.promotion.id,
                productSetId:
                    product_sets && product_sets[0] && product_sets[0].id
            }

            if (this.previewType === 'labels') {
                const paging = this.promotion.productsPagination
                const per = paging.perPage === 10 ? 100 : paging.perPage
                const page = paging.perPage === 10 ? 1 : paging.nextPage

                await this.$store.dispatch('loadLabelsProductsAndResources', {
                    ...payload,
                    per,
                    page,
                    promo: this.promotion,
                    selectedLabels: true
                })
            } else if (this.previewType === 'group-accept') {
                const res = await this.$store.dispatch(
                    'fetchProductsByPromoGroupPromo',
                    {
                        ...payload,
                        fromSelectedGroups: true
                    }
                )

                if (this.promotion.all_eans_present) {
                    return
                }

                this.$store.dispatch('setMerchantEansInSelectedPromoGroup', {
                    products: res,
                    promotion: this.promotion,
                    params: {
                        per: 99999
                    }
                })
            } else {
                this.$store.dispatch('fetchProductsByPromoGroupPromo', payload)
            }
        },
        selectAllShops(value) {
            this.$store.dispatch('selectAllMerchants', {
                promoId: this.promotion.id,
                shops: this.searchedShopsIds,
                equalPrices: true,
                groupIdx: this.priceGroupIdx,
                value,
                promotion: this.promotion,
                previewType: this.previewType,
                fromPromoDetails: this.$store.getters.modalState?.args
                    ?.singleSubscription
            })
        },
        setShowExtraFields() {
            if (document.querySelector('.button-extra-fields')) {
                this.showExtraFieldCol = true
            }
        },
        setActiveShop() {
            if (!this.promotion.equalLocalCodes && !this.hasSets) {
                const error = this.$store.getters.getLocalCodeError({
                    promoId: this.promotion.id,
                    groupId: this.groupId
                })
                if (error) {
                    this.activeShop = error.merchantId
                }
            }
        }
    },
    mounted() {
        this.setShowExtraFields()
        this.$nextTick(() => {
            setTimeout(() => {
                this.setActiveShop()
            }, 0)
        })
    },
    watch: {
        localCodeValidation() {
            this.setActiveShop()
        }
    }
}
</script>
